import { useLogMarketAnalyticsEvent } from '../../../hooks/useLogMarketAnalyticsEvent';
import { useCallback } from 'react';

export const useLogClickRequestCoupon = () => {
  const logMarketAnalytics = useLogMarketAnalyticsEvent();

  return useCallback(() => {
    logMarketAnalytics({
      name: 'CLICK_REQUEST_COUPON',
    });
  }, [logMarketAnalytics]);
};
